import React, { forwardRef } from "react";
import BaseModal from "../BaseModal";
import IEditableProps from "../../../utilities/IEditableProps";
import IStyledProps from "../../../utilities/IStyledProps";
import classNames from "classnames";
import styled from "styled-components";

export interface ICustomModalProps extends IEditableProps, IStyledProps {
    modalId: string;
    modalSize: string;
    children?: React.ReactNode;
}

export default styled(forwardRef((props: ICustomModalProps, ref: any) => {
    function showPreview() {
        if (!props.modalId) {
            return <div className="text-primary">Invalid Modal ID</div>
        }
        return (<>
            <div>Modal ID: <strong>{props.modalId}</strong> <button type="button" className="btn btn-primary p-1 ml-1" data-modal-id={props.modalId}>Open Modal</button></div>
            <div>Preview:</div>
            <div className="border p-2">
                {props.children}
            </div>
            <div>- Add <strong>data-modal-id="{props.modalId}"</strong> to an html element tag to hook modal.</div>
            <div>- Add class <strong>close-modal</strong> to an html element tag to close modal.</div>
        </>)
    }

    return (
        <div data-id={props.cmsId} ref={ref} className={classNames(props.editorClassObj, props.className)}>
            {props.cmsId ? <div className={classNames("modal-placeholder")}>
                {showPreview()}
            </div> : null}
            <BaseModal backdropClassName={"modal-backdrop-glass"} modalId={props.modalId} modalSize={props.modalSize}>
                <div className="custom-modal">{props.children}</div>
            </BaseModal>
        </div>
    );
}))`
    .modal-placeholder {
        padding: 0.5rem;
        border: 1px dashed;
    }
`;
